export default __webpack_public_path__ + "static/media/icon-throat.4bbe94eb.svg";